import {
  Sun, Volume2, Layers, PanelsLeftRight, Ruler, Box, AlignJustify, CloudRain, Lightbulb, Cpu, BadgeCheck, Lock, Maximize2, Check,
} from "lucide-react";

const ICONS = {
  thermal: Sun, acoustic: Volume2, glass: Layers, opening: PanelsLeftRight, depth: Ruler, security: Lock, size: Maximize2,
  structure: Box, louvres: AlignJustify, rain: CloudRain, led: Lightbulb, automation: Cpu, warranty: BadgeCheck,
};

const STATUS = {
  serie: { it: "Di serie", en: "Standard" },
  optional: { it: "Optional", en: "Optional" },
  richiesta: { it: "Su richiesta", en: "On request" },
};

const Tag = ({ status, lang }) => (
  <span className="ml-2 inline-block align-middle text-[10px] font-medium uppercase tracking-[0.08em] text-[#6e6e73] border border-[#d2d2d7] rounded-full px-2 py-[1px]">
    {STATUS[status][lang]}
  </span>
);

function Row({ h, lang, index }) {
  const d = h[lang] || h.it;
  const Icon = ICONS[h.icon] || Check;
  return (
    <li className="flex items-center gap-4 py-4 border-b border-[#e4e4e7] last:border-b-0" data-testid={`spec-row-${index}`}>
      <span className="w-11 h-11 rounded-xl bg-[#1D3F94]/[0.07] text-[#1D3F94] flex items-center justify-center flex-shrink-0">
        <Icon size={20} strokeWidth={1.6} />
      </span>
      <span className="w-px self-stretch bg-[#e4e4e7] flex-shrink-0" aria-hidden="true" />
      <span className="min-w-0">
        <span className="block text-[13px] text-[#6e6e73] leading-snug">
          {d.label}
          {d.status && <>{" "}<Tag status={d.status} lang={lang} /></>}
        </span>
        <span className="block text-[16px] font-semibold text-[#1d1d1f] leading-snug mt-0.5">{d.value}</span>
        {d.note && (
          <span className="block text-[13px] text-[#6e6e73] leading-snug mt-1">
            {d.note}
            {d.noteStatus && <>{" "}<Tag status={d.noteStatus} lang={lang} /></>}
          </span>
        )}
      </span>
    </li>
  );
}

export default function SpecSheet({ highlights, lang, title, wide = false }) {
  if (!highlights?.length) return null;
  const half = Math.ceil(highlights.length / 2);
  const cols = wide ? [highlights.slice(0, half), highlights.slice(half)] : [highlights];
  return (
    <div className="rounded-3xl bg-[#fafafc] border border-[#e4e4e7] shadow-[0_24px_60px_-30px_rgba(29,63,148,0.18)] p-6 md:p-8" data-testid="spec-sheet">
      <div className="text-[12px] font-semibold uppercase tracking-[0.18em] text-[#1d1d1f] mb-2">{title}</div>
      <div className={wide ? "grid grid-cols-1 md:grid-cols-2 md:gap-x-10" : ""}>
        {cols.map((col, c) => (
          <ul key={c}>
            {col.map((h, i) => <Row key={i} h={h} lang={lang} index={c * half + i} />)}
          </ul>
        ))}
      </div>
    </div>
  );
}
